module.exports = __webpack_public_path__ + "img/x-diamond-fill.c9f82be0.svg";